import { Controller } from 'stimulus';

// The org dashboard a select for VIP category in an offcanvas.
// The page also has tabs for each category. When the tabs are used, this controller
// keeps the select in sync with the tabs & submits the form
export default class extends Controller {
  static targets = ['select'];

  submit({ target }) {
    this.selectTarget.value = target.value;
    target.form.submit();
  }
}
